<template>
  <div class="login-container">
    <div style="width: 100%; height: 65px; position: fixed; top: 0; background-color: black; z-index: 10;"></div>
    <!-- 简洁的背景装饰 -->
    <div class="bg-decoration">
      <div class="bg-circle circle-1"></div>
      <div class="bg-circle circle-2"></div>
    </div>

    <!-- 主要内容区域 -->
    <div class="content-wrapper">
      <!-- 左侧品牌区域
      <div class="left-panel">
        <div class="panel-content">
          <div class="logo-section">
            <h1 class="brand-name">中青网音漫汇</h1>
            <p class="brand-desc">发现音乐与漫画的无限可能</p>
          </div>
          <div class="feature-list">
            <div class="feature-item">
              <span class="feature-icon">🎵</span>
              <span>海量音乐素材</span>
            </div>
            <div class="feature-item">
              <span class="feature-icon">🎨</span>
              <span>精彩漫画内容</span>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 右侧登录注册表单 -->
      <div class="right-panel">
        <div class="form-container">
          <!-- 标题切换 -->
          <div class="form-header">
            <h2 class="form-title">{{ isLogin ? '登录账户' : '创建账户' }}</h2>
            <p class="form-subtitle">{{ isLogin ? '欢迎回来，继续你的创意之旅' : '加入我们，开启音乐与漫画的探索之旅' }}</p>
          </div>

          <!-- 切换标签 -->
          <div class="toggle-tabs">
            <div :class="['tab', { active: isLogin }]" @click="switchToLogin">
              登录
            </div>
            <div :class="['tab', { active: !isLogin }]" @click="switchToRegister">
              注册
            </div>
          </div>

          <!-- 表单内容 -->
          <form @submit.prevent="handleSubmit" class="auth-form">
            <!-- 注册时的用户名 -->
            <div class="form-group">
              <label for="username">用户名</label>
              <div class="input-wrapper">
                <input id="username" v-model="formData.username" type="text" placeholder="请输入用户名" required
                  @input="jiance_yz(formData.username, 'U')" />
              </div>
              <!-- <p class="ys_hongse" v-show="typeFS.username">最大六位字符</p> -->
            </div>

            <!-- 手机号 -->
            <div v-if="!isLogin" class="form-group">
              <label for="email">手机号</label>
              <div class="input-wrapper">
                <input id="email" v-model="formData.sjh" type="tel" placeholder="请输入手机号" required
                  @input="jiance_yz(formData.sjh, 'S')" />
              </div>
              <p class="ys_hongse" v-show="typeFS.sjh">手机号格式不正确</p>
            </div>

            <!-- 验证码 -->
            <div v-if="!isLogin" class="form-group">
              <label for="password">验证码</label>
              <div class="input-wrapper">
                <input id="password" v-model="formData.yzm" type="text" placeholder="请输入验证码" required />
                <span class="toggle-password" @click="HQyzm()"
                  :style="{color:textYzm!=='获取验证码'?'#ccc':'#000'}">
                  {{textYzm}}
                </span>
              </div>
            </div>

            <!-- 密码 -->
            <div class="form-group">
              <label for="password">密码</label>
              <div class="input-wrapper">
                <input id="password" v-model="formData.password" :type="showPassword ? 'text' : 'password'"
                  placeholder="请输入密码" required />
                <span class="toggle-password" @click="showPassword = !showPassword">
                  {{ showPassword ? '👁️' : '🙈' }}
                </span>
              </div>
            </div>

            <!-- 注册时的确认密码 -->
            <div v-if="!isLogin" class="form-group">
              <label for="confirmPassword">确认密码</label>
              <div class="input-wrapper">
                <input id="confirmPassword" v-model="formData.confirmPassword"
                  :type="showPassword ? 'text' : 'password'" placeholder="请再次输入密码" required />
              </div>
            </div>

            <!-- 记住我 (仅登录) -->
             
            <div v-if="isLogin" class="form-options">
              <label class="checkbox-label">
                <input type="checkbox" v-model="rememberMe" />
                <span>我已阅读并同意
                  <router-link to="/UserAgreement" target="_blank">《用户协议》</router-link> 
                  以及
                  <router-link to="/PrivacyPolicy" target="_blank">《隐私政策》</router-link>  
                </span>
              </label>
              <!-- <a href="#" class="forgot-link">忘记密码？</a> -->
            </div>

            <!-- 提交按钮 -->
            <button type="submit" class="submit-btn">
              {{ isLogin ? '登录' : '注册' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'DengLu',
  data() {
    return {
      isLogin: true, // true为登录模式，false为注册模式
      showPassword: false,
      rememberMe: true,
      textYzm:'获取验证码',
      jishu:59,//yzm
      formData: {
        username: '',
        sjh: '',
        password: '',
        confirmPassword: '',
        yzm: ''
      },
      typeFS: {
        hum: false,
        sjh: false,
        psd: false,
        ocnfpsd: false,
        yzm: false
      }
    }
  },
  methods: {
    //切换登录
    switchToLogin() {
      this.isLogin = true
      this.resetForm()
    },
    //切换注册
    switchToRegister() {
      this.isLogin = false
      this.resetForm()
    },
    //清空input框
    resetForm() {
      this.formData = {
        username: '',
        jsh: '',
        password: '',
        confirmPassword: '',
        yzm: ''
      }
      this.showPassword = false
      this.rememberMe = false
    },
    //获取验证码
    HQyzm() {
      if (this.formData.sjh !==undefined && this.typeFS.sjh==false) {
        if(this.textYzm=='获取验证码'){
          this.textYzm = '('+this.jishu+')已发送验证码';
          //验证码
          let data ={phone:this.formData.sjh};
          axios.post('/api/index/code',data)
            .then(res => {
              console.log(res.data.data.code)
            }).catch(err => {
              console.log(err)
            })
          let miao = setInterval(()=>{
            this.textYzm = '('+this.jishu+')已发送验证码';
            if(this.jishu<=0){
              clearInterval(miao)//清楚定时器
            }
            this.jishu--;
          },1000)
        }else{
          
          this.$message.error('请勿重复点击');
        }
      }else{
        alert('请输入正确的手机号')
      }

    },
    //登录/注册
    handleSubmit() {
      if (this.isLogin) {
        if(this.rememberMe == true){
          this.handleLogin()
        }else{
          this.$message.warning('请先勾选协议！')
        }
      } else {
        this.handleRegister()
      }
    },
    handleLogin() {
      // 登录逻辑
      console.log('登录数据:', {
        email: this.formData.sjh,
        password: this.formData.password,
        rememberMe: this.rememberMe
      })
      // 这里可以调用API进行登录
      const data = {
        username:this.formData.username,
        password:this.formData.password
      }
      axios.post('/api/index/login',data)
      .then(res=>{
        console.log(res);
        if(res.data.code==1){
          this.$message({
            message: '登录成功',
            type: 'success',
            data:2
          });
          localStorage.setItem('zqW',JSON.stringify(res.data.data));
          this.$store.state.dlMark = JSON.parse(localStorage.getItem('zqW'));
          localStorage.setItem('isWcnrEnabled', 'false'); // 持久化关闭状态
          this.$router.push('/');
        }else{
          this.$message.error('登录失败');
        }
      }).catch(err=>{
        console.log(err)
        this.$message.error('登录失败');
      })
    },
    handleRegister() {
      // 验证密码
      if (this.formData.password !== this.formData.confirmPassword) {
        alert('两次输入的密码不一致')
        return
      }
      // 注册逻辑
      console.log('注册数据:', this.formData)
      // 这里可以调用API进行注册
      const data = {
        username:this.formData.username,
        phone:this.formData.sjh,
        password:this.formData.password,
        code:this.formData.yzm
      }
      axios.post('/api/index/register',data)
      .then(res=>{
        console.log(res);
        if(res.data.code==1){
          this.$message({
            message: '注册成功，即将跳转登录!',
            type: 'success'
          });
          this.isLogin = true;//切换登录

        }else{
          this.$message.error('注册失败，请稍后重试！');
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    //检测
    jiance_yz(index, R) {
      //手机号正则
      let sjres = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/;
      switch (R) {
        case 'U':
          //用户名正则
          if (index.length >= 1 && index.length <= 6) {
            this.typeFS.username = false;
          } else {
            this.typeFS.username = true;
          }
          break;
        case 'S':
          if (index.length != 0) {
            if (!sjres.test(index)) {
              this.typeFS.sjh = true;
            } else {
              this.typeFS.sjh = false;
            }
          }
          break;
        case 'M':
          //手机号正则
          break;
        default:
          console.log('请确保R值为字符串格式')
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.ys_hongse {
  font-size: 13px;
  color: #fa2807;
}



.login-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-image: url('https://yanghl.oss-cn-beijing.aliyuncs.com/randi/style/2.jpg');
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  padding-top: 90px;
  padding-bottom: 50px;
}

/* 简洁的背景装饰 */
.bg-decoration {
  position: absolute;
  
  inset: 0;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.03) 0%, rgba(102, 126, 234, 0.01) 100%);
}

.circle-1 {
  width: 500px;
  height: 500px;
  top: -200px;
  right: -200px;
}

.circle-2 {
  width: 400px;
  height: 400px;
  bottom: -150px;
  left: -150px;
}

/* 内容区域 */
.content-wrapper {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1000px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 左侧面板 */
.left-panel {
  padding: 0 20px;
}

.panel-content {
  .logo-section {
    margin-bottom: 60px;
  }

  .brand-name {
    font-size: 42px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 16px;
    letter-spacing: -0.5px;
    line-height: 1.2;
  }

  .brand-desc {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
  }

  .feature-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .feature-item {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 15px;
    color: #333;

    .feature-icon {
      font-size: 20px;
    }
  }
}

/* 右侧表单面板 */
.right-panel {
  width: 400px;
  background: #ffffff;
  border-radius: 16px;
  padding: 48px 40px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
  box-shadow: 0 2px 16px 0px rgba(255, 255, 255, 1);
}

.form-header {
  text-align: center;
  margin-bottom: 36px;

  .form-title {
    font-size: 28px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 8px;
    letter-spacing: -0.3px;
  }

  .form-subtitle {
    font-size: 14px;
    color: #999;
  }
}

/* 切换标签 */
.toggle-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 32px;
  background: #f5f5f5;
  padding: 4px;
  border-radius: 10px;

  .tab {
    flex: 1;
    padding: 10px 20px;
    text-align: center;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    font-size: 15px;
    color: #666;
    transition: all 0.2s ease;

    &:hover {
      color: #333;
    }

    &.active {
      background: #ffffff;
      color: #1a1a1a;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
  }
}

/* 表单样式 */
.auth-form {
  .form-group {
    margin-bottom: 20px;

    label {
      display: block;
      font-size: 13px;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
    }

    .input-wrapper {
      position: relative;
      display: flex;
      align-items: center;

      input {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        font-size: 15px;
        color: #1a1a1a;
        background: #fafafa;
        transition: all 0.2s ease;

        &:focus {
          outline: none;
          border-color: #667eea;
          background: #ffffff;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.08);
        }

        &::placeholder {
          color: #aaa;
        }
      }

      .toggle-password {
        position: absolute;
        right: 12px;
        cursor: pointer;
        font-size: 16px;
        user-select: none;
        opacity:1;
        transition: opacity 0.2s ease;
      }
    }
  }

  .form-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    font-size: 13px;

    .checkbox-label {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #666;
      cursor: pointer;

      input[type="checkbox"] {
        width: 16px;
        height: 16px;
        cursor: pointer;
        accent-color: #667eea;
      }
      a{
        text-decoration: none;
        color: #666;
      }
    }

    .forgot-link {
      color: #667eea;
      text-decoration: none;
      font-weight: 500;
      transition: color 0.2s ease;

      &:hover {
        color: #5568d3;
      }
    }
  }

  .submit-btn {
    width: 100%;
    padding: 14px;
    background: #667eea;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: #5568d3;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .divider {
    position: relative;
    margin: 24px 0;
    color: #aaa;
    font-size: 13px;



    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }
  }

  .social-login {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;

    .social-btn {
      padding: 12px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      background: #ffffff;
      font-size: 14px;
      font-weight: 500;
      color: #666;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        border-color: #667eea;
        color: #667eea;
        background: #fafafa;
      }

      &.wechat:hover {
        border-color: #07c160;
        color: #07c160;
      }

      &.qq:hover {
        border-color: #12b7f5;
        color: #12b7f5;
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 968px) {
  .content-wrapper {
    grid-template-columns: 1fr;
    gap: 50px;
    max-width: 500px;
  }

  .left-panel {
    text-align: center;
    padding: 0;
  }

  .panel-content {
    .logo-section {
      margin-bottom: 40px;
    }

    .brand-name {
      font-size: 36px;
    }

    .brand-desc {
      font-size: 15px;
    }

    .feature-list {
      align-items: center;
    }
  }

  .right-panel {
    padding: 40px 32px;
  }
}

@media (max-width: 600px) {
  .login-container {
    padding: 20px 10px;
  }

  .right-panel {
    padding: 32px 24px;
    border-radius: 12px;
  }

  .form-header .form-title {
    font-size: 24px;
  }

  .panel-content {
    .brand-name {
      font-size: 28px;
    }

    .brand-desc {
      font-size: 14px;
    }
  }

  .social-login {
    grid-template-columns: 1fr;
  }
}
</style>
